import Color from "color";

export const hexToLCH = (hexColor: any = "#000000"): { l: string; c: number; h: number } => {
  if (hexColor === "#000000") {
    return { l: "0%", c: 0, h: 276 };
  }
  const inputColor = Color(hexColor);
  const lch = inputColor.lch();
  return {
    l: `${lch.color[0].toFixed(2)}%`,
    c: parseFloat(lch.color[1].toFixed(2)),
    h: hexColor === "#222222" || hexColor === "#CACACA" ? 276 : parseInt(lch.color[2].toFixed(0)),
  };
};

export const rgbToHex = (rgb: string): string | null => {
  const hex = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
  return hex
    ? `#${((1 << 24) | (parseInt(hex[1]) << 16) | (parseInt(hex[2]) << 8) | parseInt(hex[3]))
        .toString(16)
        .slice(1)}`
    : null;
};

export const nameToHex = (color: string): string => {
  const temp = document.createElement("div");
  temp.style.color = color;
  document.body.appendChild(temp);
  const computedStyle = window.getComputedStyle(temp);
  const hexColor = computedStyle.color;
  document.body.removeChild(temp);
  return hexColor;
};

export const colorToHex = (color: string): string | null => {
  if (/^[a-zA-Z]+$/.test(color)) {
    return nameToHex(color);
  }
  if (/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/.test(color)) {
    return rgbToHex(color);
  }
  if (/^#[0-9A-F]{6}$/i.test(color)) {
    return color;
  }
  return null;
};

export const calculateLuminance = (color: { r: number; g: number; b: number }): number => {
  const { r, g, b } = color;
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

export const parseColor = (color: string): { r: number; g: number; b: number } | null => {
  const hex = colorToHex(color);
  if (hex) {
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    const fullHex = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  }
  return null;
};
